import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  widgetTitle: {
    margin: 0,
    fontSize: 18,
    fontWeight: 600,
    color: theme.custom.darkBlue,
  },
  title: {
    margin: 0,
    marginBottom: 15,
    fontSize: 17,
    fontWeight: 400,
    color: theme.custom.darkBlue,
  },
  box: {
    padding: 15,
    flexBasis: 'calc(100% / 3)',
    '@media (max-width: 1800px)': {
      maxWidth: '50%',
      flexBasis: '50%',
      paddingLeft: 10,
      paddingRight: 10,
    },
    [theme.breakpoints.down(768)]: {
      width: '100%',
      flexBasis: '100%',
      maxWidth: '100%',
    },
  },
}));
